<template>
  <div>
    <v-row>
      <v-col cols="12">
        <div class="form-base__title">
          Реквизиты документа, подтверждающего полномочия представителя
        </div>
      </v-col>

      <v-col>
        <v-radio-group v-model="v.type.$model" row>
          <v-radio
            label="Иной документ"
            :value="DocumentType.CONFIRMATION_OF_AUTHORITY"
          />
          <v-radio
            label="Нотариально заверенная доверенность"
            :value="DocumentType.NOTARY_POWER_ATTORNEY"
          />
        </v-radio-group>
      </v-col>
    </v-row>

    <NotaryDocument
      v-if="v.type.$model === DocumentType.NOTARY_POWER_ATTORNEY"
      :v="v"
      title-hidden
    />
    <AuthorityDocument
      v-if="v.type.$model === DocumentType.CONFIRMATION_OF_AUTHORITY"
      :v="v"
      title-hidden
    />
  </div>
</template>

<script>
import { getValidationErrorText } from '@/utils/validate';
import { DocumentType } from '@/types/services';
import NotaryDocument, {
  notaryDocumentModel,
  notaryDocumentValidation,
} from '@/components/services/elements/NotaryDocument';
import AuthorityDocument, {
  authorityDocumentModel,
  authorityDocumentValidation,
} from '@/components/services/elements/AuthorityDocument';
import deepmerge from 'deepmerge';

export const getEgrnOrganizationAuthorityDocumentValidation = (
  authorityDocument
) => {
  let scheme = {
    type: {},
  };

  if (authorityDocument.type === DocumentType.CONFIRMATION_OF_AUTHORITY) {
    scheme = deepmerge(scheme, authorityDocumentValidation);
  }

  if (authorityDocument.type === DocumentType.NOTARY_POWER_ATTORNEY) {
    scheme = deepmerge(scheme, notaryDocumentValidation);
  }

  return scheme;
};

export const egrnOrganizationAuthorityDocumentModel = {
  ...authorityDocumentModel,
  ...notaryDocumentModel,
  type: DocumentType.CONFIRMATION_OF_AUTHORITY,
};

export default {
  name: 'EgrnOrganizationAuthorityDocument',
  components: {
    AuthorityDocument,
    NotaryDocument,
  },
  props: {
    v: {
      type: Object,
      required: true,
    },
  },
  data: () => ({
    getValidationErrorText,
    DocumentType,
  }),
  computed: {
    authorityDocumentType() {
      return this.v.type.$model;
    },
  },
  watch: {
    authorityDocumentType(val) {
      if (val === DocumentType.CONFIRMATION_OF_AUTHORITY) {
        this.v.name.$model = null;
        this.v.issuer.$model = null;
        this.v.attestation.$model = null;
        this.v.number.$model = null;
        this.v.series.$model = null;
      }

      if (val === DocumentType.NOTARY_POWER_ATTORNEY) {
        this.v.regNumber.$model = null;
      }

      this.v.docDate.$model = null;
      this.v.file.$model = null;
      this.v.fileSig.$model = null;
    },
  },
};
</script>
